var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ShoppingCart',{attrs:{"line-items":_vm.lineItems,"total":_vm.totalItem,"isReady":_vm.isReady,"bg":"bg-[#F7F7FC] p-2"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }